var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcDownload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#555597",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M14 10v2.667c0 .353-.14.692-.39.943-.25.25-.59.39-.943.39H3.333c-.353 0-.692-.14-.942-.39S2 13.02 2 12.667V10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#555597",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M4.668 6.668l3.333 3.333 3.334-3.333M8 10V2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_download.19cc743f.svg";
export { ForwardRef as ReactComponent };